/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconCard16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCard16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path d="M5 9a1 1 0 0 0 0 2h2a1 1 0 1 0 0-2H5Z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H3Zm0 9.5V8h10v3.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5ZM3 6h10V4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V6Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCard24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCard24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M18.795 5H5.205c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 0 0-.945.945C2.116 6.686 2 7.09 2 8.205v7.59c0 1.115.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h13.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926v-7.59c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 0 0-.945-.945C20.314 5.116 19.91 5 18.795 5ZM4.356 7.049c.155-.03.422-.049.849-.049h13.59c.427 0 .694.019.849.049.06.012.074.017.134.049a.275.275 0 0 1 .125.124c.031.06.036.073.048.134.03.155.049.422.049.849V9H4v-.795c0-.427.019-.694.049-.849a.353.353 0 0 1 .049-.134.275.275 0 0 1 .124-.124.353.353 0 0 1 .134-.049ZM4 11h16v4.795c0 .427-.019.694-.049.849a.353.353 0 0 1-.049.134.275.275 0 0 1-.124.125.353.353 0 0 1-.134.048c-.155.03-.422.049-.849.049H5.205c-.427 0-.694-.019-.849-.049a.353.353 0 0 1-.134-.049.275.275 0 0 1-.124-.124.353.353 0 0 1-.049-.134c-.03-.155-.049-.422-.049-.849V11Zm3 4a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2H7Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconCard = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCard(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconCard16 {...iconProps} />;
        case '24':
            return <IconCard24 {...iconProps} />;
        default:
            return <IconCard24 {...iconProps} />;
    }
});
